module.exports = __webpack_public_path__ + "static/1.1.E.6 FORNA PLAN PARTER-d1bfc02b9214ce65e8905f9e3d0e1c85.jpg";